'use client';

import { motion } from '@/libs';

import { ICATU_CONTACTS } from '../../constants';

type PrizeInfoProps = {
  animatedValue: number;
  capitalizer?: string | null;
  canRedraw?: boolean;
};

export const PrizeInfo = ({
  animatedValue,
  capitalizer,
  canRedraw = true,
}: PrizeInfoProps) => {
  const isIcatuCapitalizer = capitalizer?.toLowerCase().includes('icatu') ?? false;

  return (
    <motion.div
      className="flex flex-col items-center gap-4 w-full relative z-20 mb-4"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
    >
      <div className="w-full rounded-lg md:p-8 text-center">
        <motion.p
          className="text-2xl md:text-3xl font-bold text-primary-foreground mb-2 uppercase"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, delay: 0.4 }}
        >
          {isIcatuCapitalizer ? 'Parabéns pelo prêmio!' : 'Parabéns'}
        </motion.p>
        {!isIcatuCapitalizer && (
          <motion.p
            className="text-base font-medium md:text-lg text-primary-foreground mb-2 uppercase"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.4, delay: 0.4 }}
          >
            você foi contemplado!
          </motion.p>
        )}
        <motion.p
          className="text-2xl md:text-3xl font-bold text-primary-foreground"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
        >
          {animatedValue.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </motion.p>
      </div>
      <motion.p
        className="text-sm text-primary-foreground text-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: 0.6 }}
      >
        {isIcatuCapitalizer
          ? `Para receber seu prêmio, basta entrar em contato com a Icatu Capitalização: SAC ${ICATU_CONTACTS.sac} / Ouvidoria ${ICATU_CONTACTS.ouvidoria} / CRC ${ICATU_CONTACTS.crc}.`
          : canRedraw
            ? 'Seu prêmio foi registrado e está disponível para saque.'
            : 'Para valores acima de R$ 2.000,00. Nosso time entrará em contato com você em até dois dias úteis para realizar o pagamento do seu prêmio.'}
      </motion.p>
    </motion.div>
  );
};
